import { render, staticRenderFns } from "./RecipientModal.vue?vue&type=template&id=acb49206&scoped=true&"
import script from "./RecipientModal.vue?vue&type=script&lang=js&"
export * from "./RecipientModal.vue?vue&type=script&lang=js&"
import style0 from "./RecipientModal.vue?vue&type=style&index=0&id=acb49206&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb49206",
  null
  
)

export default component.exports